import { AppCardMedia } from '@app/components/base/app-card';
import { webApi } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { FragmentCardMediaOverlay } from '../base/FragmentCardMediaOverlay';
import { AudioFragmentWaveform } from './AudioFragmentWaveform';

/**
 * Media area for audio fragment: waveform with time/duration pill overlay.
 */
export function AudioFragmentMedia({ fragment }: { fragment: webApi.FragmentListItemDto }) {
  return (
    <AppCardMedia sx={{ minWidth: 0 }}>
      <FragmentCardMediaOverlay
        fragment={fragment}
        sx={{
          height: 100, // Defines the height of the waveform area
          width: '100%',
          minWidth: 0, // Allow flex item to shrink below content size
          bgcolor: (theme) =>
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
          display: 'flex',
          alignItems: 'stretch', // So waveform fills height
        }}
      >
        {/* Explicit size so waveform canvas gets correct dimensions */}
        <Box sx={{ width: '100%', height: '100%', minWidth: 0, my: '10px' }}>
          <AudioFragmentWaveform fragment={fragment} />
        </Box>
      </FragmentCardMediaOverlay>
    </AppCardMedia>
  );
}
